import React from "react";
import { Link } from 'gatsby'
import MoreIcon from '../../img/more-icon.png';
import Button from '../Button'

import "../../styles/cms.scss";

const MyArticleMore = ({ link = "", cta = "", text = "", label ="Zobacz również:", cta_type = "secondary" }) => {
  return (
    <Link to={link} title={text} className="more-link">
      <div className="more-wrapper">
        <div className="more-container">
          <img src={MoreIcon} alt={text} />
          <div className="more-content">
            <p className="label">{label}</p>
            <div>{text}</div>
          </div>
        </div>
        <div className="button-wrapper">
          <Button type={cta_type}>
            <span> {cta}</span>
          </Button>
        </div>
      </div>
    </Link>
  );
};

export default MyArticleMore;
